import { handleResponseLanguage } from '../../../../../../../i18n';
import { useFlowsSelector } from '../../../../../../common/src/utils/globalVariables';
import { isLowerCaseStringEqual } from '../../../../../../common/src/utils/stringUtils';
import store from '../../../../store/redux/store';
import { FlowTagContent } from '../../../../types/FlowsTypes';

const useTagContent = (tag?: string): string => {
  const flowsResponse = useFlowsSelector((state) => state.flows.flowsResponse);

  const tagContent = flowsResponse?.tag_content?.find(({ tag: _tag }) =>
    isLowerCaseStringEqual(_tag, tag),
  );

  if (tagContent?.title) return handleResponseLanguage(tagContent.title);

  return '';
};

export const getTagContentFromStore = (tag: string): string => {
  const tagContentArray = store.getState().flows.flowsResponse?.tag_content;

  if (tagContentArray) return getTagContentFromArray(tag, tagContentArray);

  return '';
};

export const getTagContentFromArray = (
  tag: string,
  tagContentArray: FlowTagContent[],
): string => {
  const tagContent = tagContentArray?.find(({ tag: _tag }) =>
    isLowerCaseStringEqual(_tag, tag),
  );

  if (tagContent?.title) return handleResponseLanguage(tagContent.title);

  return '';
};

export default useTagContent;
